const RootzSlide = [
    {
        id: 1,
        backImg: require('../img/Slider/slider-img-1.png'),
        title: 'Save watter',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    },
    {
        id: 2,
        backImg: require('../img/Slider/slider-img-2.png'),
        title: 'Plant trees',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    },
    {
        id: 3,
        backImg: require('../img/Slider/slider-img-3.png'),
        title: 'Save energy',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    },
    {
        id: 4,
        backImg: require('../img/Slider/slider-img-4.png'),
        title: 'Save watter',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    },
    {
        id: 5,
        backImg: require('../img/Slider/slider-img-5.png'),
        title: 'Avoid plastic',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    },
    {
        id: 6,
        backImg: require('../img/Slider/slider-img-6.png'),
        title: 'Choose organic',
        desc: `Taking on the issue of ensuring access to safe water requires worldwide effort.`,
    }
]
export default RootzSlide;